import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();
  
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('about.title')} <span className="text-amber-600">{t('about.titleHighlight')}</span>
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {t('about.intro')}
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {t('about.paragraph1')}
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              {t('about.paragraph2')}
            </p>
            
            <div className="grid grid-cols-1 gap-6">
              <div className="bg-amber-50 p-6 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-600 text-white rounded-full mb-4">
                  <i className="ri-heart-line text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('about.lifetimeSupport')}</h3>
                <p className="text-gray-600">{t('about.lifetimeSupportDesc')}</p>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img
                  src="https://public.readdy.ai/ai/img_res/de75d97a620e7a1a11d945fc6fe2623f.jpg"
                  alt="Happy family with puppy"
                  className="w-full h-64 object-cover object-top rounded-2xl shadow-lg"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Cute%20maltipoo%20puppy%20being%20gently%20held%20by%20caring%20hands%20in%20bright%20clean%20environment%2C%20soft%20lighting%2C%20tender%20moment%2C%20professional%20pet%20photography%2C%20high%20quality%2C%20loving%20care%2C%20simple%20background&width=400&height=300&seq=about-002&orientation=landscape"
                  alt="Caring for puppy"
                  className="w-full h-48 object-cover object-top rounded-2xl shadow-lg"
                />
              </div>
              <div className="space-y-4 pt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Adorable%20poodle%20and%20maltipoo%20puppies%20playing%20together%20on%20soft%20blanket%20in%20bright%20room%2C%20playful%20interaction%2C%20natural%20lighting%2C%20cute%20and%20energetic%2C%20professional%20pet%20photography%2C%20high%20quality%2C%20simple%20clean%20background&width=400&height=300&seq=about-003&orientation=landscape"
                  alt="Puppies playing"
                  className="w-full h-48 object-cover object-top rounded-2xl shadow-lg"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Beautiful%20groomed%20poodle%20puppy%20sitting%20elegantly%20in%20bright%20modern%20home%20setting%2C%20professional%20appearance%2C%20soft%20lighting%2C%20high%20quality%20pet%20photography%2C%20clean%20and%20sophisticated%2C%20simple%20background&width=400&height=500&seq=about-004&orientation=portrait"
                  alt="Groomed puppy"
                  className="w-full h-64 object-cover object-top rounded-2xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
